import axios from 'axios'

const endpoint = '/api/auth'

export default {
  logout: () => axios.get(`${endpoint}/logout`),
}
